export function checkFaders() {
  var faders = document.querySelectorAll('.fade:not(.faded)');
  
  faders.forEach((el) => {
    let trigger = el.dataset.trigger || 1;
    if (inScreen(el, trigger)) {
      el.classList.add('faded');
    }
  });
}

export function inScreen(el, k) {
  let box = el.getBoundingClientRect();

  return window.innerHeight * k > box.top;
}

export default checkFaders;
